





















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import {
  isDepositTransactionDetails,
  isPayoutTransactionDetails,
  isStringTransactionDetails,
  Transaction,
} from "@teacherskaya/api-provider/dist/api/TransactionProvider";
import { TableItem, TableItems } from "@/types";
import { formatDate } from "@/lib/helpers/time";
import { $t } from "@/lib/helpers/i18nHelper";
import { TEXT } from "@/lib/const";
import { formatMoney, getCurrencySymbol, CREDITS_CURRENCY_CODE } from "@/lib/helpers/money";
import BaseTable from "@/components/BaseTable.vue";

@Component({ name: "TransactionsTable", components: { BaseTable } })
export default class TransactionsTable extends Vue {
  @Prop({ type: Array, required: true })
  public readonly transactions!: Transaction[];

  public loadingId: string = "";

  get currentCurrency() {
    return getCurrencySymbol(CREDITS_CURRENCY_CODE);
  }

  public isCorrectionOrPayout(type: string): boolean {
    return type === "Payout" || type === "Correction";
  }

  get tableItems(): TableItems {
    return this.transactions.map(transaction => {
      return {
        id: transaction.id,
        amount: transaction.amount,
        amountText: formatMoney(transaction.amount, { withSymbol: false, withSign: true }),
        type: $t(transaction.type),
        user: (transaction.user && transaction.user.screenName) || null,
        userId: (transaction.user && transaction.user.id) || null,
        date: formatDate(transaction.time),
        description: this.formatDescription(transaction),
        reference: TEXT.FIELD_EMPTY,
        actions: false,
      };
    });
  }

  public formatDescription(transaction: Transaction): string {
    if (isPayoutTransactionDetails(transaction.details)) {
      const data = transaction.details;
      return data.payeeInfo && data.payeeInfo.payoutSystem
        ? $t("Payout via {0}", [$t(data.payeeInfo.payoutSystem || "")])
        : $t("Payout");
    } else if (isDepositTransactionDetails(transaction.details)) {
      return $t("Deposit via {0}: {1}", [$t(transaction.details.paymentSystem), transaction.reference]);
    } else if (isStringTransactionDetails(transaction.details)) {
      return transaction.details.description;
    } else {
      return "";
    }
  }

  public profileLink(row: TableItem): Location {
    if (!row.userId) return {};
    return {
      name: "profile",
      params: { userId: row.userId.toString() },
    };
  }

  public onDelete(transactionId: string) {
    if (this.loadingId) {
      return;
    }

    this.loadingId = transactionId;
    this.$emit("deleteTransaction", { id: transactionId, cd: () => (this.loadingId = "") });
  }
}
